import {  createSlice } from "@reduxjs/toolkit";

const betSlice = createSlice({
  name: "bet",
  initialState: null,
  reducers: {
    clearBet(state) {
      state = null;

      return state;
    },
    setActiveBet(state, action) {
      state = action.payload;

      return state;
    }
  }
});

export const { setActiveBet, clearBet } = betSlice.actions;
export default betSlice.reducer;
